const numberFormat = new Intl.NumberFormat("en-US");

const isBad = (n: number | null | undefined): n is null | undefined =>
  n == null || !Number.isFinite(n);

export const count = (n: number | null) => (isBad(n) ? "-" : numberFormat.format(Math.round(n)));

export const money = (n: number | null, decimals = 0) =>
  isBad(n)
    ? "-"
    : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }).format(n);

export const duration = (totalSeconds: number | null) => {
  if (isBad(totalSeconds)) return "-";
  const s = Math.round(totalSeconds);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const rem = s % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${rem}s`;
  return `${rem}s`;
};

export const futureDate = (days: number | null) => {
  if (isBad(days)) return "-";
  const d = new Date();
  d.setDate(d.getDate() + Math.ceil(days));
  return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
};

export const divide = (a: number, b: number) => (b > 0 ? a / b : null);
export const ceilDiv = (a: number, b: number) => (b > 0 ? Math.ceil(a / b) : null);
